(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-campaign"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MOBILE = '(max-width: 767px)';

  // Measure how far the full-height hero starts down the page -- that is the
  // theme header -- and hand it to CSS, so 100svh means "the rest of the
  // screen" rather than "a screenful starting below the header". Runs as soon
  // as the script parses so there is no visible resize.
  function fitFullHero() {
    document.querySelectorAll('.lpc-hero--full').forEach(function (hero) {
      hero.style.setProperty('--lpc-hero-offset', '0px');
      var top = hero.getBoundingClientRect().top + (window.scrollY || 0);
      // Guard against odd layouts: only ever subtract a plausible header.
      var offset = Math.max(0, Math.min(Math.round(top), 240));
      hero.style.setProperty('--lpc-hero-offset', offset + 'px');
    });
  }
  fitFullHero();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitFullHero);
  }
  var fitTimer;
  window.addEventListener('resize', function () {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(fitFullHero, 150);
  });
  window.addEventListener('orientationchange', fitFullHero);

  // Videos that asked to play but were refused. iOS blocks muted autoplay
  // outright in Low Power Mode, and only relents after the person touches the
  // page -- so we keep them here and retry on the first interaction.
  var pending = [];
  var gestureBound = false;

  function bindGesture() {
    if (gestureBound) return;
    gestureBound = true;
    var retry = function () {
      pending.splice(0).forEach(function (fn) { fn(); });
      document.removeEventListener('touchstart', retry);
      document.removeEventListener('click', retry);
      document.removeEventListener('scroll', retry);
      gestureBound = false;
    };
    document.addEventListener('touchstart', retry, { passive: true, once: true });
    document.addEventListener('click', retry, { once: true });
    document.addEventListener('scroll', retry, { passive: true, once: true });
  }

  function initVideo(holder) {
    if (holder.dataset.lpcInit) return;
    var isMobile = window.matchMedia(MOBILE).matches;
    var src = isMobile ? holder.dataset.mobile : holder.dataset.desktop;
    if (!src) src = holder.dataset.desktop || holder.dataset.mobile;
    if (!src) return;
    holder.dataset.lpcInit = '1';

    var v = document.createElement('video');
    v.muted = true;
    v.defaultMuted = true;
    v.loop = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.setAttribute('muted', '');
    v.setAttribute('loop', '');
    v.setAttribute('aria-hidden', 'true');
    v.setAttribute('preload', 'auto');
    v.src = src;
    holder.appendChild(v);

    // iOS quietly downgrades preload to 'none' on cellular and in Low Power
    // Mode. Waiting on 'canplay' before calling play() then deadlocks: nothing
    // loads until play() is called, and play() never fires because the event
    // never arrives. So ask to play straight away, and again on each readiness
    // event, rather than gating the first attempt on one of them.
    var started = false;
    function tryPlay() {
      if (started) return;
      var p = v.play();
      if (p && p.then) {
        p.then(function () {
          started = true;
          holder.classList.add('is-ready');
        }).catch(function () {
          if (pending.indexOf(tryPlay) === -1) pending.push(tryPlay);
          bindGesture();
        });
      } else {
        started = true;
        holder.classList.add('is-ready');
      }
    }

    v.addEventListener('loadeddata', tryPlay);
    v.addEventListener('canplay', tryPlay);
    v.addEventListener('playing', function () {
      started = true;
      holder.classList.add('is-ready');
    });
    // Safari needs the explicit load() when it has decided not to preload.
    try { v.load(); } catch (e) {}
    tryPlay();
  }

  function boot() {
    fitFullHero();
    // Motion is opt-out for reduced-motion and data-saver users.
    var allowMotion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
                      !(navigator.connection && navigator.connection.saveData);
    if (allowMotion) {
      // The hero starts once the page has settled, so its poster stays the LCP.
      document.querySelectorAll('.lpc-hero [data-lpc-video]').forEach(initVideo);

      // Banner and split videos wait until they are nearly on screen, so a page
      // with several of them does not download them all up front.
      var lazy = document.querySelectorAll('.lpc-banner [data-lpc-video], .lpc-split [data-lpc-video], .lpc-feature [data-lpc-video]');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { initVideo(e.target); io.unobserve(e.target); }
          });
        }, { rootMargin: '200px 0px' });
        lazy.forEach(function (el) { io.observe(el); });
      } else {
        lazy.forEach(initVideo);
      }
    }

    // Click-to-play lookbook tiles. The cover image stays put until the video
    // actually has a frame to show -- hiding it on click left a grey box for
    // however long the film took to buffer, which on a phone is seconds.
    document.querySelectorAll('[data-lpc-tile-play]').forEach(function (btn) {
      if (btn.dataset.lpcBound) return;
      btn.dataset.lpcBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var media = btn.closest('.lpc-tile__media');
        var tpl = media && media.querySelector('[data-lpc-tile-video]');
        if (!tpl || media.dataset.lpcPlaying) return;
        media.dataset.lpcPlaying = '1';

        media.appendChild(tpl.content.cloneNode(true));
        var vid = media.querySelector('video');
        if (!vid) return;

        // The cover doubles as the video's own poster, so even the frame
        // between reveal and first paint is the photograph, never grey.
        var cover = media.querySelector('img');
        var coverSrc = cover && (cover.currentSrc || cover.src);
        if (coverSrc && !vid.getAttribute('poster')) vid.setAttribute('poster', coverSrc);

        if (!vid.src) {
          var wantMobile = window.matchMedia(MOBILE).matches;
          var tsrc = (wantMobile ? vid.dataset.mobile : vid.dataset.desktop) ||
                     vid.dataset.desktop || vid.dataset.mobile;
          if (tsrc) vid.src = tsrc;
        }
        vid.setAttribute('playsinline', '');
        vid.setAttribute('webkit-playsinline', '');
        vid.playsInline = true;
        vid.preload = 'auto';

        // Button stays, turns into a spinner, so the tap has visible feedback.
        media.classList.add('is-loading');
        btn.classList.add('is-busy');
        btn.setAttribute('aria-label', 'Loading film');

        var done = false;
        function reveal() {
          if (done) return;
          done = true;
          media.classList.remove('is-loading');
          media.classList.add('is-playing');
          btn.remove();
        }
        function fail() {
          if (done) return;
          done = true;
          media.classList.remove('is-loading');
          btn.classList.remove('is-busy');
          btn.setAttribute('aria-label', 'Play film');
          delete media.dataset.lpcPlaying;
          if (vid.parentNode) vid.parentNode.removeChild(vid);
        }

        // Picture-in-picture (and fullscreen) lift the video element out of the
        // page. The tile is then an empty box -- grey, because the cover was
        // hidden when playback began. So put the cover back while the video is
        // living elsewhere, and hide it again when it returns.
        function coverBack() {
          media.classList.remove('is-playing');
          media.classList.add('is-pip');
        }
        function coverAway() {
          media.classList.remove('is-pip');
          if (done) media.classList.add('is-playing');
        }
        vid.addEventListener('enterpictureinpicture', coverBack);
        vid.addEventListener('leavepictureinpicture', coverAway);
        // Safari on iOS reports this instead, and also uses it for fullscreen.
        vid.addEventListener('webkitpresentationmodechanged', function () {
          if (vid.webkitPresentationMode === 'inline') { coverAway(); } else { coverBack(); }
        });
        vid.addEventListener('webkitendfullscreen', coverAway);

        vid.addEventListener('playing', reveal, { once: true });
        vid.addEventListener('loadeddata', function () {
          // Enough decoded to paint. Safe to swap even if 'playing' is slow.
          if (vid.readyState >= 2) reveal();
        });
        vid.addEventListener('error', fail, { once: true });

        var pr = vid.play();
        if (pr && pr.catch) pr.catch(function () {
          // Autoplay refusal on a real tap is rare, but a genuine load failure
          // is not -- give it a moment to recover before handing the tile back.
          setTimeout(function () { if (!done && vid.readyState < 2) fail(); }, 6000);
        });
      });
    });

    // In-page links (a hero button pointing at #films, say) scroll rather than
    // jump. Handled here rather than with scroll-behavior on <html> so it can't
    // change how the rest of the theme scrolls.
    document.querySelectorAll('.lp-campaign a[href*="#"]').forEach(function (a) {
      if (a.dataset.lpcAnchor) return;
      var raw = a.getAttribute('href') || '';
      var url;
      try { url = new URL(raw, location.href); } catch (e) { return; }
      var hash = url.hash;
      if (hash.length < 2) return;
      if (url.origin !== location.origin) return;
      // Same page? Compare the last path segment rather than the whole path, so
      // a market prefix such as /en-gb/pages/x still matches a link typed as
      // /pages/x. Anything else is left alone and navigates normally.
      var here = location.pathname.replace(/\/$/, '').split('/').pop();
      var there = url.pathname.replace(/\/$/, '').split('/').pop();
      if (there && there !== here) return;
      var target;
      try { target = document.querySelector(hash); } catch (e) { return; }
      if (!target) return;
      a.dataset.lpcAnchor = '1';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var jump = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: jump ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', hash);
      });
    });

    // rolling strip: clone the slides until they overflow twice, then translate
    // the track by half its width so the loop is seamless.
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-lpc-marquee]').forEach(function (vp) {
      if (vp.dataset.lpcInit) return;
      var track = vp.querySelector('.lpc-marquee__track');
      if (!track || !track.children.length) return;
      vp.dataset.lpcInit = '1';
      // Static strips and reduced-motion users get a plain swipeable row:
      // no cloning, no animation.
      if (reduce || vp.classList.contains('lpc-marquee--static')) return;

      var originals = Array.prototype.slice.call(track.children);
      var guard = 0;
      while (track.scrollWidth < vp.offsetWidth * 2 && guard < 12) {
        originals.forEach(function (n) {
          var c = n.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          track.appendChild(c);
        });
        guard++;
      }
      Array.prototype.slice.call(track.children).forEach(function (n) {
        var c = n.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      });

      var speed = parseFloat(vp.dataset.speed) || 60;
      var half = track.scrollWidth / 2;
      track.style.setProperty('--lpc-mq-dur', (half / speed).toFixed(1) + 's');
      vp.classList.add('is-running');
    });

    // rail arrows
    document.querySelectorAll('[data-lpc-rail-nav]').forEach(function (nav) {
      var section = nav.closest('.lpc-shop');
      var rail = section && section.querySelector('[data-lpc-rail]');
      if (!rail) return;
      nav.querySelectorAll('[data-dir]').forEach(function (b) {
        if (b.dataset.lpcBound) return;
        b.dataset.lpcBound = '1';
        b.addEventListener('click', function () {
          var card = rail.querySelector('.lpc-card');
          var step = card ? card.getBoundingClientRect().width + 16 : 316;
          rail.scrollBy({ left: step * parseInt(b.dataset.dir, 10), behavior: 'smooth' });
        });
      });
    });
  }

  if (document.readyState === 'complete') { boot(); }
  else { window.addEventListener('load', boot); }

  // theme editor support
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
